import React from 'react'
import './Multiposting.scss'

const Multiposting = () => {
  return (
    <div>Multiposting</div>
  )
}

export default Multiposting